import helper from '@/libs/forms';

export default {
  schema: {
    fields: [
      helper.checkbox(
        'Click here to confirm that you have read and understood the information above.',
        'agreed',
        '',
        true,
        12,
      ),
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/agreement/schema.js